import { Add, MoreVert } from '@mui/icons-material';
import { Box, Button, ButtonBase, IconButton, MenuItem, Pagination, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useEffect } from 'react'
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BgBox from '../../../components/BgBox';
import { customAlert } from '../../../components/notify';
import OptionMenu from '../../../components/OptionMenu';
import StyledSwitch from '../../../components/StyledSwitch';
import StyledTableContainer from '../../../components/StyledTableContainer';
import { useAuthContext } from '../../../context/AuthContext';
import route from '../../../Routes';
import { getAllCustWPgSch, putCustStatus } from '../../../services/cust-service';
import { capFirstLetter } from '../../../utils/format';
import { useTranslation } from "react-i18next";
import { useQuery } from 'react-query'
import LoadingScreen from '../../../components/loadingScreen';
import QueryKey from '../../../QueryKey';
import SearchTxtFieldClr from '../../../components/SearchTxtFieldClr';
import { FilterAlt } from '@mui/icons-material';
import FilterMdl from './FilterMdl';
import { DEFAULT_PAGE_SIZE } from '../../../constants/pagination';
import RecordCount from "../../../components/RecordCount";

function CustListPage() {
    const { setAsyncLoading, setLastSeenObjFn } = useAuthContext();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();
    // const isLarge = useMediaQuery("(min-width: 600px)");
    const [currMenuCustId, setCurrMenuCustId] = useState(null);
    const limit = DEFAULT_PAGE_SIZE;
    const { t } = useTranslation();

    // const [searchKeyWord, setSearchKeyWord] = useState("");
    // const [searchWord, setSearchWord] = useState("");
    // const [pageNumber, setPageNumber] = useState(1);

    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const custRole = searchParams.get("custRole") || "";
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);

    const [filterObj, setFilterObj] = useState({
        fromDate: '',
        toDate: ''
    });
    const [filterMdl, setFilterMdl] = useState(false);
    const handleFilterMdlClose = () => setFilterMdl(false);
    const handleFilterMdlOpen = () => setFilterMdl(true);

    function handleFilterObj(obj) {
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
        setFilterObj({ ...obj })
    }

    const { isLoading, isError, error, data: custRows, refetch } = useQuery(
        [QueryKey.custList, pgNo, isSrchBtnClick, filterObj, custRole],
        () => getAllCustWPgSch({ pageNumber: pgNo, limit, searchKeyWord: searchWord, custRole, ...filterObj }),
        {
            keepPreviousData: true
        }
    )

    function handleRoleTab(role) {
        setSearchParams(prev => {
            prev.set("custRole", role)
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    useEffect(() => {
        setLastSeenObjFn('cust');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    if (isLoading)
        return <Box sx={{ position: "absolute", top: 0, left: 0 }}><LoadingScreen /></Box>


    const columns = [
        {
            id: 'custName',
            label: t("bo.cusLstPg.cusName"),
            minWidth: 170,
            align: 'left',
        },
        {
            id: 'username',
            label: t("bo.cusLstPg.contact"),
            minWidth: 170
        },
        {
            id: 'type',
            label: t("bo.cusLstPg.type"),
            minWidth: 170
        },
        {
            id: 'agentCode',
            label: t("bo.cusLstPg.agCode"),
            minWidth: 170,
            align: 'center',
        },
        {
            id: 'verified',
            label: t("bo.cusLstPg.verified"),
            minWidth: 170,
            align: 'center',
        },
        {
            id: 'status',
            label: t("bo.cusLstPg.sts"),
            minWidth: 80,
            align: 'center',
        },
        {
            id: 'options',
            label: '',
            // align: 'right',
            minWidth: 80
        },
    ];

    const optionItems = [
        {
            title: t("bo.cusLstPg.edit"),
            fn: handleEdit
        },
        {
            title: t("bo.cusLstPg.addReq"),
            fn: handleAddReq
        },
        {
            title: t("bo.cusLstPg.viewLedger"),
            fn: handleViewLedger
        }
    ]


    const handleOptionClick = (event, custId) => {
        setAnchorEl(event.currentTarget);
        setCurrMenuCustId(custId);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    async function handleEdit() {
        handleClose();
        navigate(route.boEditCust + currMenuCustId);
    }

    async function handleAddReq() {
        handleClose();
        navigate(route.boAddCustReq + "?custId=" + currMenuCustId);

    }

    async function handleViewLedger() {
        handleClose();
        navigate(route.boCustLedger + "?custId=" + currMenuCustId);
    }

    async function handleRowClick(custRow) {
        handleClose();
        navigate(route.boCustInfo + custRow.custId);
    }

    async function handleAgCodeClick(custRow) {
        if (custRow.cByType === 'agent') {
            handleClose();
            navigate(route.boAgentInfo + custRow.createdBy);
        }
    }

    async function updateCustStatus(custRow) {
        setAsyncLoading(true);
        try {
            let status = custRow.status === 1 ? 0 : 1;
            await putCustStatus(custRow.custId, status)
            refetch();
        } catch (err) {
            // console.log(err);
            customAlert(err)
        }
        setAsyncLoading(false)
    }

    function handleAddCustClick() {
        navigate(route.boAddCust);
    }

    function onSearchBtnClick() {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            return prev
        }, { replace: true })
    }

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };



    function verified(custRow) {
        if (custRow.aadhar_verified === 1 || custRow.pan_verified === 1 || custRow.gst_verified === 1)
            return <Typography sx={{ color: "green" }}>Yes</Typography>

        return <Typography sx={{ color: "red" }}>No</Typography>
    }

    return (
        <BgBox>
            <Stack direction={'row'} justifyContent='space-between' m={2} >
                <Stack direction={'row'} alignItems={"center"} gap={2}>
                    <Typography variant='h5' sx={{ fontWeight: "bold" }}>{t("bo.cusLstPg.cust")}<RecordCount count={custRows?.totalLength} /></Typography>
                    <Stack direction={'row'} gap={0.5} ml={2}>
                        <ButtonBase component="div" onClick={() => handleRoleTab("")}>
                            <Typography sx={{ fontWeight: "600", color: custRole !== "consignee" ? "primary.main" : "text.secondary" }}>{t("bo.cusLstPg.cnorTab")}</Typography>
                        </ButtonBase>
                        <Typography sx={{ color: "text.secondary", mx: 0.5 }}>|</Typography>
                        <ButtonBase component="div" onClick={() => handleRoleTab("consignee")}>
                            <Typography sx={{ fontWeight: "600", color: custRole === "consignee" ? "primary.main" : "text.secondary" }}>{t("bo.cusLstPg.cneeTab")}</Typography>
                        </ButtonBase>
                    </Stack>
                </Stack>
                <Stack direction={'row'} justifyContent="end">

                    <SearchTxtFieldClr handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={t("bo.cusLstPg.srchCus")} />

                    <Button variant='outlined' sx={{ ml: 2 }} startIcon={<FilterAlt />} color='primary' onClick={handleFilterMdlOpen} >{t("bo.reptListPg.filter")}</Button>
                    <Button variant='contained' sx={{ ml: 2 }} startIcon={<Add />} color='primary' onClick={handleAddCustClick}>{t("bo.cusLstPg.createCus")}</Button>
                </Stack>
            </Stack>
            <StyledTableContainer height={"83%"}>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                align={column.align}
                                style={{ minWidth: column.minWidth }}
                                sx={{ color: "#8392AB", fontWeight: "bold", py: 1 }}
                                key={column.id}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {custRows?.data.map((custRow) => {
                        return (
                            <TableRow hover tabIndex={-1} key={custRow.custId} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                {columns.map((column) => {
                                    const value = custRow[column.id];
                                    return (
                                        (column.id === 'status') ?
                                            <TableCell key={column.id} align={column.align}>
                                                <StyledSwitch checked={custRow.status ? true : false} onClick={() => { updateCustStatus(custRow) }} />
                                            </TableCell> : (column.id === 'options') ?
                                                <TableCell key={column.id} align={column.align}>
                                                    <IconButton onClick={(e) => { handleOptionClick(e, custRow.custId) }}>
                                                        <MoreVert />
                                                    </IconButton>
                                                </TableCell> : (column.id === 'custName') ?
                                                    <TableCell key={column.id} align={column.align} >
                                                        <Button variant="text" sx={{ color: "#000000" }} onClick={() => { handleRowClick(custRow); }}>
                                                            {capFirstLetter(custRow.fName) + " " + capFirstLetter(custRow.lName)}
                                                        </Button>
                                                    </TableCell> : (column.id === 'verified') ?
                                                        <TableCell key={column.id} align={column.align} >
                                                            {verified(custRow)}
                                                        </TableCell> : (column.id === 'agentCode') ?
                                                            <TableCell key={column.id} align={column.align} >
                                                                <Button variant="text" sx={{ color: "#000000" }} onClick={() => { handleAgCodeClick(custRow); }}>
                                                                    {custRow.agentCode}
                                                                </Button>
                                                            </TableCell> :
                                                            <TableCell key={column.id} align={column.align} >
                                                                {column.format && typeof value === 'number' ? column.format(value) : capFirstLetter(value)}
                                                            </TableCell>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>


            </StyledTableContainer>
            <Stack sx={{ alignItems: "center", mt: 1 }}>
                <Pagination count={Math.ceil(custRows?.totalLength / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
                    variant="outlined" shape="rounded" />
            </Stack>

            <OptionMenu open={open} handleClose={handleClose} anchorEl={anchorEl} >
                {optionItems.map((i) => <MenuItem
                    sx={{ pl: 2, pr: 5 }}
                    key={i.title}
                    onClick={i.fn}>
                    {i.title}
                </MenuItem>)}
            </OptionMenu>
            <FilterMdl modalOpen={filterMdl} handleModalClose={handleFilterMdlClose} filterObj={filterObj} handleFilterObj={handleFilterObj} />
        </BgBox>
    )
}

export default CustListPage